// extracted by css-extract-rspack-plugin
export default {"subActions":"subActions-RslqMC","action":"action-pIFmvq"};